import { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "@/lib/blogApi";

const Context = createContext(null);
export const useOwner = () => useContext(Context);
export const AdminProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  useEffect(() => {
    let active = true;
    adminApi.get("/auth/me").then(({ data }) => { if (active) setUser(data); }).catch(() => {}).finally(() => { if (active) setChecking(false); });
    const expired = () => setUser(null);
    window.addEventListener("owner-session-expired", expired);
    return () => { active = false; window.removeEventListener("owner-session-expired", expired); };
  }, []);
  return <Context.Provider value={{ user, setUser, checking }}>{children}</Context.Provider>;
};